// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wxdialecticalchart[data-v-d69c3da6] {\n  background-color: #fff;\n  border-radius: 30px;\n  padding: 57px 46px 60px 51px;\n  margin-top: 45px;\n}\n.wxdialecticalchart .title[data-v-d69c3da6] {\n    color: #333;\n    font-size: 48px;\n    font-family: PingFangSC-Medium;\n    width: 340px;\n    height: 50px;\n    border-left: 6px solid #1288eb;\n    text-align: center;\n    margin-bottom: 30px;\n}\n", ""]);
// Exports
module.exports = exports;
